import React from 'react';

import styles from './Sections.module.scss';

import { termsSections } from '../../utils/Terms';

export const Sections = () => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1>Roomvu Terms And Conditions</h1>
      </div>
      <div className={styles.contentWrapper}>
        {termsSections.map((section, i) => {
          return (
            <div key={i}>
              {section.title && <h2>{section.title}</h2>}
              {section.subtitle && <h3>{section.subtitle}</h3>}
              {section.paragraphs?.map((paragraph, index) => {
                return (
                  <div key={index}>
                    <p dangerouslySetInnerHTML={{ __html: paragraph.text }} />
                    {paragraph.list && (
                      <ul style={{ listStyleType: paragraph.listType }}>
                        {paragraph.list.map((listItem, listIndex) => {
                          return (
                            <li
                              key={listIndex}
                              dangerouslySetInnerHTML={{ __html: listItem }}
                            />
                          );
                        })}
                      </ul>
                    )}
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
};
